var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7H6.41667C6.24865 7.05893 6.09635 7.15553 5.97143 7.28241C5.84651 7.40929 5.75228 7.56307 5.69598 7.73199C5.63967 7.90091 5.62278 8.08047 5.64659 8.25693C5.67039 8.43338 5.73428 8.60205 5.83334 8.75L11.6667 15.1667V19.8333L16.3333 23.3333V15.1667L18.6667 13.4167",
    stroke: "url(#paint0_linear_603_25398)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 3.5V10.5M16.3333 7H23.3333H16.3333Z",
    stroke: "url(#paint1_linear_603_25398)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_603_25398",
    x1: 5.63611,
    y1: 15.1667,
    x2: 18.6667,
    y2: 15.1667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_603_25398",
    x1: 16.3333,
    y1: 7,
    x2: 23.3333,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3912D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A312D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.a8ef5919b1574fb96ed6661a09034c1f.svg";
export { ForwardRef as ReactComponent };